export const etextMcqIconCorrect = `
  <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <title>Correct Answer Icon</title>
    <g fill="none" fill-rule="evenodd">
    <circle cx="50" cy="50" r="50"/>
    <path d="M82.373 34.837L43.677 75.31c-2.154 2.253-5.602 2.253-7.756 0L16.616 54.943c-2.155-2.253-2.155-5.893 0-8.146 2.154-2.254 5.602-2.254 7.756 0L39.885 63.09l34.818-36.4c2.154-2.253 5.602-2.253 7.756 0 2.069 2.253 2.069 5.893-.086 8.147z" fill="#FFF" fill-rule="nonzero"/>
    </g>
  </svg>
`;

export const etextMcqIconIncorrect = `
  <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <title>Incorrect Answer Icon</title>
    <g fill="none" fill-rule="evenodd">
      <circle cx="50" cy="50" r="50"/>
      <path d="M54.61 50.03l19.402-19.24a3.35 3.35 0 000-4.75 3.418 3.418 0 00-4.79 0L50 45.041 30.778 25.98a3.418 3.418 0 00-4.79 0 3.35 3.35 0 000 4.75l19.401 19.24-19.401 19.3a3.35 3.35 0 000 4.75 3.418 3.418 0 004.79 0L50 54.958 69.222 74.02a3.418 3.418 0 004.79 0 3.35 3.35 0 000-4.75L54.611 50.03z" fill="#FFF" fill-rule="nonzero"/>
    </g>
  </svg>
`;

export const RESPONSE_HEADER_CORRECT = `<p dir="ltr">That's correct.</p>`;
export const RESPONSE_HEADER_INCORRECT = `<p dir="ltr">That's incorrect. Try again.</p>`;

export const MCQ_SUBMIT_BUTTON_LABEL = "SUBMIT";
export const MCQ_TRY_AGAIN_BUTTON_LABEL = "TRY AGAIN";
